import $ from 'jquery';
import { MEDIUM, CROSS_BREAKPOINT } from 'breakpoint-controller';

const SELECTOR = '.link-menu.is-style-horizontal-menu';
const OVERFLOW_ELEMENT_WIDTH = 105;
const MOBILE = 'mobile';
const DESKTOP = 'desktop';

let mode = false;
let $els = [];

function onDocumentReady() {
	$els = $(SELECTOR);

	if ($els.length > 0) {
		$els.each(initializeElement);
		$(document)
		.on(CROSS_BREAKPOINT, onCrossBreakpoint)
		.on('click', '.toggle-overflow', onClickToggleOverflow);
	}
}

function onClickToggleOverflow(e) {
	const clicked = $(e.currentTarget);

	clicked.toggleClass('active').next('.overflow-items').slideToggle();
}

function initializeElement(i, el) {
	const $el = $(el);
	const headingWidth = $el.find('.heading').outerWidth();
	const linkContainer = $el.find('.links');
	const links = linkContainer.find('a');

	const overflowElement = getOverflowElement();
	const overflowContainer = overflowElement.find('.overflow-items');
	const overflowToggle = overflowElement.find('.toggle-overflow');

	$el.data({ headingWidth, links, linkContainer, overflowElement, overflowContainer, overflowToggle });

	links.each((i, link) => {
		const $l = $(link);
		const width = $l.outerWidth();
		$l.data({ width });

		setTimeout(() => {
			$l.addClass('initialized');
		}, i * 200);
	});

	linkContainer.append(overflowElement);

	refreshOverflow($el);
}

function onCrossBreakpoint(e, breakpoint) {
	if(breakpoint < MEDIUM) {
		setMode(MOBILE);
	} else {
		setMode(DESKTOP);
	}

	e.stopPropagation();
}

function setMode(_mode) {
	if (mode === _mode) {
		return;
	}

	mode = _mode;

	switch(mode) {
		case MOBILE:
			$(window).off('resize', onWindowResize);
			$els.each((i, el) => resetLinks($(el)));
			break;

		case DESKTOP:
			$(window).on('resize', onWindowResize);
			onWindowResize();
			break;

	}
}

function onWindowResize() {
	$els.each((i, el) => refreshOverflow($(el)));
}

function getOverflowElement() {
	return $(`
		<div class="overflow">
			<button class="toggle-overflow">More</button>
			<div class="overflow-items"></div>
		</div>
	`);
}

function resetLinks($el) {
	const elData = $el.data();
	const links = elData.links;
	const linkContainer = elData.linkContainer;
	const overflowElement = elData.overflowElement;

	links.each((i, link) => linkContainer.append(link));
	linkContainer.append(overflowElement);
}

function refreshOverflow($el) {
	if (mode === MOBILE) {
		return resetLinks($el);
	}

	const limit = window.innerWidth - OVERFLOW_ELEMENT_WIDTH;
	let hasOverflowed = false;
	let cursor = $el.data('headingWidth');

	$el.data('links').each((i, link) => {
		const $link = $(link);

		cursor += $link.data('width');
		if (cursor >= limit) {
			hasOverflowed = true;
		}

		if (hasOverflowed) {
			$el.data('overflowContainer').append($link);
		} else if ($link.parents('overflow-items')) {
			$el.data('overflowElement').before($link);
		}
	});

	if (hasOverflowed) {
		$el.data('overflowToggle').fadeIn();
	} else {
		$el.data('overflowToggle').fadeOut();
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
